var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSimpleSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.628,
    height: 13.628,
    viewBox: "0 0 13.628 13.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-spotify",
    "data-name": "Icon simple-spotify",
    d: "M6.814,0a6.814,6.814,0,1,0,6.814,6.814A6.834,6.834,0,0,0,6.814,0ZM9.949,9.846a.406.406,0,0,1-.58.136,7.8,7.8,0,0,0-6-.648.421.421,0,1,1-.2-.817,8.711,8.711,0,0,1,6.609.75A.409.409,0,0,1,9.949,9.846Zm.818-1.874a.515.515,0,0,1-.717.17,8.83,8.83,0,0,0-6.779-.784.518.518,0,0,1-.307-.989,9.972,9.972,0,0,1,7.666.92.481.481,0,0,1,.137.681Zm.068-1.908a11.29,11.29,0,0,0-7.9-.783.626.626,0,0,1-.375-1.194,12.644,12.644,0,0,1,8.927.92.659.659,0,0,1,.238.886A.713.713,0,0,1,10.835,6.064Z",
    fill: "#f49a56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSimpleSpotify);
export default __webpack_public_path__ + "static/media/icon-simple-spotify.d1bc82783a8283f51ed93b3e1d303955.svg";
export { ForwardRef as ReactComponent };